import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  en: {
    nav: {
      home: "Home",
      cars: "Cars",
      locations: "Locations",
      about: "About",
      contact: "Contact",
      myBookings: "My Bookings",
      signIn: "Sign In",
    },
    hero: {
      tagline: "DRIVE THE DOMINICAN",
      title: "Rent a car. Own the road.",
      subtitle:
        "Premium vehicles, transparent pricing, and 24/7 support — from Santo Domingo to JFK New York.",
      ctaSearch: "Find a car",
      ctaBrowse: "Browse fleet",
    },
    search: {
      pickup: "Pick-up location",
      dropoff: "Drop-off location",
      pickupDate: "Pick-up date",
      dropoffDate: "Drop-off date",
      sameLocation: "Return to same location",
      search: "Search cars",
      driverAge: "Driver age",
      adult: "30+ years",
    },
    features: {
      h: "Why DAMS",
      a: "Unlimited mileage",
      aDesc: "Drive as far as the road takes you, with no hidden caps.",
      b: "Free cancellation",
      bDesc: "Plans change. Cancel up to 48 hours before pick-up — at no cost.",
      c: "24/7 roadside support",
      cDesc: "Help is always one call away, anywhere in the country.",
      d: "Best price guarantee",
      dDesc: "Find a lower rate elsewhere? We'll match it and beat it by 5%.",
    },
    locations: {
      title: "Pick up where it's convenient",
      subtitle: "Six locations across the Dominican Republic and the US.",
      taxLabel: "Tax",
      minLabel: "Min",
      days: "days",
      day: "day",
    },
    cars: {
      title: "Our fleet",
      results: "vehicles",
      sortLabel: "Sort",
      sortPriceAsc: "Price: low to high",
      sortPriceDesc: "Price: high to low",
      sortName: "Name (A–Z)",
      filtersTitle: "Filters",
      category: "Category",
      seats: "Seats",
      anyLocation: "Any location",
      priceRange: "Price per day",
      clear: "Clear filters",
      noResults: "No vehicles match your filters.",
      perDay: "/day",
      seatsLabel: "seats",
      bookNow: "Book now",
      viewDetails: "View details",
    },
    detail: {
      back: "Back to fleet",
      specs: "Vehicle specs",
      transmission: "Transmission",
      fuel: "Fuel",
      seats: "Seats",
      bags: "Bags",
      category: "Category",
      mileage: "Mileage",
      unlimited: "Unlimited",
      minDriver: "Minimum driver age",
      yearsOld: "years",
      features: "Features",
      pickup: "Pick-up",
      dropoff: "Drop-off",
      summary: "Trip summary",
      pricePerDay: "Price per day",
      days: "Rental days",
      subtotal: "Subtotal",
      tax: "Tax",
      total: "Total",
      proceed: "Continue to checkout",
      noFeatures: "No features listed.",
      reviews: "What renters say",
    },
    checkout: {
      title: "Checkout",
      step: "Step",
      of: "of",
      driver: "Driver information",
      payment: "Payment",
      review: "Review",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      license: "Driver's license",
      country: "Country",
      birthDate: "Date of birth",
      address: "Address",
      city: "City",
      zip: "ZIP / Postal code",
      flightNo: "Flight number (optional)",
      next: "Continue",
      back: "Back",
      paymentMethod: "Payment method",
      stripe: "Card (Stripe)",
      cash: "Pay in cash at pick-up",
      cardNumber: "Card number",
      cardName: "Name on card",
      expiry: "Expiry (MM/YY)",
      cvc: "CVC",
      cashNotice:
        "Your booking will be reserved as Pending Payment. Pay in cash when you pick up your car.",
      stripeNotice:
        "Mock payment — no card will be charged. Use any test number to continue.",
      confirm: "Confirm booking",
      processing: "Processing...",
      tripSummary: "Your trip",
    },
    confirm: {
      title: "Booking confirmed!",
      pendingTitle: "Booking received",
      subtitle:
        "Your reservation is locked in. A copy of your receipt has been emailed to {email}.",
      pendingSubtitle:
        "Bring the exact amount in cash at pick-up. Reservation # {ref}.",
      reservation: "Reservation #",
      backHome: "Back to home",
      newBooking: "Make another booking",
      summary: "Reservation summary",
    },
    footer: {
      rights: "All rights reserved.",
      legal: "Terms",
      privacy: "Privacy",
      help: "Help center",
      getApp: "Get the app",
      downloadAndroid: "Download Android App",
      downloadIos: "Download on the App Store",
      version: "Version",
    },
    contact: {
      eyebrow: "WE ARE HERE FOR YOU",
      title: "Need help? Talk to us.",
      subtitle:
        "Our team is available around the clock for booking changes, pick-up help, or anything else.",
      fastest: "Fastest reply",
      whatsappTitle: "Chat with us on WhatsApp",
      whatsappDesc: "Reply usually within a few minutes — even on weekends.",
      whatsappCta: "Open WhatsApp",
      primary: "Primary",
      hours: "24/7 — including holidays",
      email: "Email us",
      emailDesc: "Best for receipts, invoices, and longer questions.",
      headquarters: "Headquarters",
      alreadyBookedTitle: "Already have a reservation?",
      alreadyBookedDesc: "Sign in to view, change, or cancel your booking.",
      viewBookings: "View my bookings",
    },
    common: {
      from: "From",
      to: "To",
      duration: "Duration",
      loading: "Loading...",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      cars: "Vehículos",
      locations: "Ubicaciones",
      about: "Nosotros",
      contact: "Contacto",
      myBookings: "Mis reservas",
      signIn: "Iniciar sesión",
    },
    hero: {
      tagline: "MANEJA POR REPÚBLICA DOMINICANA",
      title: "Alquila un auto. Dueño del camino.",
      subtitle:
        "Vehículos premium, precios transparentes y soporte 24/7 — desde Santo Domingo hasta JFK Nueva York.",
      ctaSearch: "Buscar un auto",
      ctaBrowse: "Ver flota",
    },
    search: {
      pickup: "Lugar de recogida",
      dropoff: "Lugar de devolución",
      pickupDate: "Fecha de recogida",
      dropoffDate: "Fecha de devolución",
      sameLocation: "Devolver en el mismo lugar",
      search: "Buscar autos",
      driverAge: "Edad del conductor",
      adult: "30+ años",
    },
    features: {
      h: "Por qué DAMS",
      a: "Kilometraje ilimitado",
      aDesc: "Conduce tan lejos como quieras, sin límites ocultos.",
      b: "Cancelación gratuita",
      bDesc: "Los planes cambian. Cancela hasta 48 horas antes — sin costo.",
      c: "Asistencia 24/7",
      cDesc: "Ayuda a una llamada, en cualquier parte del país.",
      d: "Mejor precio garantizado",
      dDesc: "Encuentra un precio menor y lo igualamos con un 5% de descuento.",
    },
    locations: {
      title: "Recoge donde te convenga",
      subtitle: "Seis ubicaciones en República Dominicana y Estados Unidos.",
      taxLabel: "Impuesto",
      minLabel: "Mín",
      days: "días",
      day: "día",
    },
    cars: {
      title: "Nuestra flota",
      results: "vehículos",
      sortLabel: "Ordenar",
      sortPriceAsc: "Precio: menor a mayor",
      sortPriceDesc: "Precio: mayor a menor",
      sortName: "Nombre (A–Z)",
      filtersTitle: "Filtros",
      category: "Categoría",
      seats: "Asientos",
      anyLocation: "Cualquier ubicación",
      priceRange: "Precio por día",
      clear: "Limpiar filtros",
      noResults: "Ningún vehículo coincide con tus filtros.",
      perDay: "/día",
      seatsLabel: "asientos",
      bookNow: "Reservar ahora",
      viewDetails: "Ver detalles",
    },
    detail: {
      back: "Volver a la flota",
      specs: "Especificaciones",
      transmission: "Transmisión",
      fuel: "Combustible",
      seats: "Asientos",
      bags: "Maletas",
      category: "Categoría",
      mileage: "Kilometraje",
      unlimited: "Ilimitado",
      minDriver: "Edad mínima del conductor",
      yearsOld: "años",
      features: "Características",
      pickup: "Recogida",
      dropoff: "Devolución",
      summary: "Resumen del viaje",
      pricePerDay: "Precio por día",
      days: "Días de alquiler",
      subtotal: "Subtotal",
      tax: "Impuesto",
      total: "Total",
      proceed: "Continuar al pago",
      noFeatures: "Sin características listadas.",
      reviews: "Lo que dicen los clientes",
    },
    checkout: {
      title: "Pago",
      step: "Paso",
      of: "de",
      driver: "Datos del conductor",
      payment: "Pago",
      review: "Revisar",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo",
      phone: "Teléfono",
      license: "Licencia de conducir",
      country: "País",
      birthDate: "Fecha de nacimiento",
      address: "Dirección",
      city: "Ciudad",
      zip: "Código postal",
      flightNo: "Número de vuelo (opcional)",
      next: "Continuar",
      back: "Atrás",
      paymentMethod: "Método de pago",
      stripe: "Tarjeta (Stripe)",
      cash: "Pagar en efectivo al recoger",
      cardNumber: "Número de tarjeta",
      cardName: "Nombre en la tarjeta",
      expiry: "Vencimiento (MM/AA)",
      cvc: "CVC",
      cashNotice:
        "Tu reserva quedará como Pago Pendiente. Paga en efectivo al recoger el auto.",
      stripeNotice:
        "Pago simulado — no se cobrará ninguna tarjeta. Usa cualquier número de prueba.",
      confirm: "Confirmar reserva",
      processing: "Procesando...",
      tripSummary: "Tu viaje",
    },
    confirm: {
      title: "¡Reserva confirmada!",
      pendingTitle: "Reserva recibida",
      subtitle:
        "Tu reserva está asegurada. Te enviamos una copia del recibo a {email}.",
      pendingSubtitle:
        "Trae el monto exacto en efectivo al recoger. Reserva # {ref}.",
      reservation: "Reserva #",
      backHome: "Volver al inicio",
      newBooking: "Hacer otra reserva",
      summary: "Resumen de la reserva",
    },
    footer: {
      rights: "Todos los derechos reservados.",
      legal: "Términos",
      privacy: "Privacidad",
      help: "Centro de ayuda",
      getApp: "Obtén la app",
      downloadAndroid: "Descargar app de Android",
      downloadIos: "Descargar en App Store",
      version: "Versión",
    },
    contact: {
      eyebrow: "ESTAMOS PARA AYUDARTE",
      title: "¿Necesitas ayuda? Hablamos contigo.",
      subtitle:
        "Nuestro equipo está disponible las 24 horas para cambios de reserva, ayuda con la entrega o cualquier consulta.",
      fastest: "Respuesta más rápida",
      whatsappTitle: "Escríbenos por WhatsApp",
      whatsappDesc: "Respondemos en pocos minutos — incluso los fines de semana.",
      whatsappCta: "Abrir WhatsApp",
      primary: "Principal",
      hours: "24/7 — incluso días festivos",
      email: "Escríbenos un correo",
      emailDesc: "Ideal para recibos, facturas y consultas largas.",
      headquarters: "Oficina central",
      alreadyBookedTitle: "¿Ya tienes una reserva?",
      alreadyBookedDesc: "Inicia sesión para ver, modificar o cancelar tu reserva.",
      viewBookings: "Ver mis reservas",
    },
    common: {
      from: "Desde",
      to: "Hasta",
      duration: "Duración",
      loading: "Cargando...",
    },
  },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("dams_lang") || "en");

  useEffect(() => {
    localStorage.setItem("dams_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path, vars) => {
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else return path;
    }
    if (typeof cur !== "string") return path;
    if (!vars) return cur;
    return cur.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
  };

  return (
    <I18nContext.Provider value={{ lang, t, setLang: setLangState }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
